<template>
  <div id="Cplx">
    <div class="header">
      <el-form :inline="true" class="demo-form-inline forms">
        <el-form-item label="产品名称：">
          <el-input v-model.trim="Name" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
          <el-button type="primary" @click="add">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <div class="content">
        <!-- :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)" -->
        <el-table :data="tableData" style="width: 100%" ref="table">
          <el-table-column prop="id" label="编号" key="id"></el-table-column>
          <el-table-column
            prop="name"
            label="产品名称"
            key="name"
          ></el-table-column>
          <el-table-column
            label="创建时间"
            prop="createdAt"
            key="createdAt"
          ></el-table-column>
          <el-table-column width="180" prop label="操作">
            <template slot-scope="scope">
              <span @click="bj(scope.$index, scope.row)" class="btns"
                >编辑</span
              >
              <span @click="sc(scope.$index, scope.row)" class="btns"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="button">
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          @current-change="current_change"
          :current-page="currentPage"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="修改产品类型"
      :visible.sync="editFormVisible"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="handleClose"
    >
      <el-form
        :model="editForm"
        label-width="120px"
        ref="editForm"
        :rules="rules"
      >
        <el-form-item label="产品名称：" prop="name">
          <el-input v-model.trim="editForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item
          class="ts"
          v-for="(part, index) in editForm.position"
          :key="index"
        >
          <el-form-item :label="'产品部位' + (index + 1) + ':'" required>
            <el-input @input="changeSetInput" v-model="part.name"></el-input>
          </el-form-item>
          <el-form-item :label="'部位系数' + (index + 1) + ':'">
            <el-input @input="changeSetInput" v-model="part.ratio"></el-input>
          </el-form-item>
          <el-button @click.prevent="edtRemovePosition(index)">删除</el-button>
        </el-form-item>
      </el-form>
      <div style="color: red; text-align: center">
        注：部位系数单位为%在不填写得情况下会根据部位数量默认平均分配（系数不可超过100%）
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="edtPosition">新增产品部位</el-button>
        <el-button @click.native="handleCancel('editForm')">取消</el-button>
        <el-button type="primary" @click.native="handleUpdate('editForm')"
          >更新</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="添加产品类型"
      :visible.sync="newData"
      :close-on-click-modal="false"
      class="edit-form"
      :before-close="newClose"
    >
      <el-form
        :model="newForm"
        label-width="100px"
        ref="newForm"
        :rules="rules"
      >
        <el-form-item label="产品名称：" prop="name">
          <el-input v-model.trim="newForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item
          class="ts"
          v-for="(part, index) in newForm.position"
          :key="index"
        >
          <el-form-item :label="'产品部位' + (index + 1) + ':'" required>
            <el-input @input="changeSetInput" v-model="part.name"></el-input>
          </el-form-item>
          <el-form-item :label="'部位系数' + (index + 1) + ':'">
            <el-input @input="changeSetInput" v-model="part.ratio"></el-input>
          </el-form-item>
          <el-button @click.prevent="removePosition(index)">删除</el-button>
        </el-form-item>
      </el-form>
      <div style="color: red; text-align: center">
        注：部位系数单位为%在不填写得情况下会根据部位数量默认平均分配（系数不可超过100%）
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addPosition">新增产品部位</el-button>
        <el-button @click.native="newCancel('newForm')">取消</el-button>
        <el-button type="primary" @click.native="newUpdate('newForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCPLX } from "../axios/api";
import moment from "dayjs";
export default {
  data() {
    return {
      Name: "",
      pagesize: 10, //每页的数据条数
      limitUpload: 1,
      editFormVisible: false, //编辑弹框
      newData: false, //添加弹框
      editForm: {
        name: "",
        position: [
          {
            name: "",
            ratio: null,
            type: null,
          },
        ],
      }, //编辑弹框数据
      newForm: {
        name: "",
        position: [
          {
            name: "",
            ratio: null,
            type: null,
          },
        ],
      }, //添加弹框数据
      loading: true,
      total: 0, //默认数据总数
      pagesize: 10, //每页的数据条数
      currentPage: 1, //默认开始页面
      tableData: [],
      dialogFormVisible: false,
      form: {},
      rules: {
        name: [{ required: true, message: "请输入产品名称", trigger: "blur" }],
      },
    };
  },
  methods: {
    changeSetInput() {
      this.$forceUpdate();
    },
    // 添加部位
    addPosition() {
      this.newForm.position.push({
        name: "",
        ratio: null,
        type: null,
      });
      this.$forceUpdate();
    },
    // 删除部位
    removePosition(index) {
      if (index !== -1) {
        this.newForm.position.splice(index, 1);
      }
      this.$forceUpdate();
    },
    // 修改
    edtPosition() {
      this.editForm.position.push({
        name: "",
        ratio: null,
        type: null,
      });
      this.$forceUpdate();
    },
    edtRemovePosition(index) {
      if (index !== -1) {
        this.editForm.position.splice(index, 1);
      }
      this.$forceUpdate();
    },
    //搜索
    search: function () {
      var that = this;
      that.currentPage = 1;
      that.init();
    },
    reset: function () {
      (this.Name = ""), (this.currentPage = 1);
      this.init();
    },
    add: function () {
      this.newData = true; //显示弹框
    },
    //点击关闭dialog
    newClose(done) {
      this.newData = false;
      this.newForm = {};
      this.newForm.position = [
        {
          name: "",
          ratio: null,
          type: null,
        },
      ];
    },
    //点击取消
    newCancel(formName) {
      this.newData = false;
      this.newForm = {};
      this.newForm.position = [
        {
          name: "",
          ratio: null,
          type: null,
        },
      ];
    },
    edit(index, row) {
      this.dialogFormVisible = true;
      this.form = Object.assign(row);
      console.log(this.form);
    },

    //点击添加
    newUpdate() {
      var that = this;
      this.$refs["newForm"].validate((valid) => {
        if (valid) {
          let isPass = false;
          let totalRation = 0;
          that.newForm.position.map((position, index) => {
            if (position.name == "") {
              that.$message({
                type: "warning",
                message: "产品部位不能为空！",
              });
              isPass = false;
            } else {
              position.type = index + 1;

              position.ratio = position.ratio
                ? parseFloat(position.ratio)
                : (100 / that.newForm.position.length).toFixed("2");

              totalRation += position.ratio;

              if (totalRation > 100) {
                that.$message({
                  type: "warning",
                  message: "系数综合不能超过100%",
                });
                isPass = false;
              } else {
                isPass = true;
              }
            }
          });
          if (isPass) {
            var data = {
              name: that.newForm.name,
              position: that.newForm.position,
            };

            console.log(data);
            // return;
            getCPLX
              .addTable(JSON.stringify(data))
              .then(function (res) {
                // console.log(res)
                if (res.code !== 0) {
                  that.$alert(res.message + "!", "提示", {
                    confirmButtonText: "确定",
                  });
                } else {
                  that.$message({
                    type: "success",
                    message: "添加成功!",
                  });

                  that.$refs["newForm"].resetFields();
                  that.newForm.position = [
                    {
                      name: "",
                      ratio: "",
                      type: null,
                    },
                  ];
                  that.newData = false;
                  // that.currentPage = 1;
                  that.init();
                }
              })
              .catch(function (res) {
                //清空
                (that.newForm = {}), that.$refs["newForm"].resetFields();
                that.newData = false;
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    current_change: function (currentPage) {
      // console.log(currentPage)
      var that = this;
      this.currentPage = currentPage;
      this.init();
    },
    //点击编辑
    bj: function (index, row) {
      console.log(row);
      var that = this;
      this.editFormVisible = true; //显示弹框
      that.editForm.name = row.name;
      that.editForm.id = row.id;

      that.editForm.position = row.position;
    },
    //点击关闭dialog
    handleClose(done) {
      this.editFormVisible = false;
      this.editForm.position = [
        {
          name: "",
          ratio: null,
          type: null,
        },
      ];
    },
    //点击取消
    handleCancel(formName) {
      this.editFormVisible = false;
      this.editForm.position = [
        {
          name: "",
          ratio: null,
          type: null,
        },
      ];
    },

    //点击更新
    handleUpdate() {
      var that = this;
      //更新的时候就把弹出来的表单中的数据写到要修改的表格中
      let isPass = false;
      let totalRation = 0;
      that.editForm.position.map((position, index) => {
        if (position.name == "") {
          that.$message({
            type: "warning",
            message: "产品部位不能为空！",
          });
          isPass = false;
        } else {
          position.type = index + 1;

          position.ratio = position.ratio
            ? parseFloat(position.ratio)
            : (100 / that.editForm.position.length).toFixed("2");

          totalRation += position.ratio;

          if (totalRation > 100) {
            that.$message({
              type: "warning",
              message: "系数综合不能超过100%",
            });
            isPass = false;
          } else {
            isPass = true;
          }
        }
      });

      if (isPass) {
        var data = {
          name: that.editForm.name,
          position: that.editForm.position,
        };

        console.log(data);
        // return;
        getCPLX
          .editTable(data, that.editForm.id)
          .then(function (res) {
            if (res.code !== 0) {
              that.$alert(res.message + "!", "提示", {
                confirmButtonText: "确定",
              });
            } else {
              that.$message({
                type: "success",
                message: "更新成功!",
              });
              that.editFormVisible = false;
              // that.currentPage = 1;
              that.init();
            }
          })
          .catch(function (res) {
            that.editFormVisible = false;
            // console.log(res)
            that.$alert(res + "!", "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    //点击删除
    sc: function (index, row) {
      var that = this;
      // console.log(row)
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          getCPLX
            .delTable({
              id: row.id,
            })
            .then(function (res) {
              if (res.code !== 0) {
                that.$alert(res.message + "!", "提示", {
                  confirmButtonText: "确定",
                });
                that.currentPage = 1;
              } else {
                // that.currentPage = 1;
                that.init();
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            })
            .catch(function (res) {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    init: function () {
      var that = this;
      that.loading = true;
      //获取产品类型列表

      //获取产品原型
      getCPLX
        .getTable({
          name: that.Name ? that.Name : undefined,
          pageNumber: that.currentPage,
          pageSize: that.pagesize,
        })
        .then(function (res) {
          // console.log(res)
          if (res.code !== 0) {
            that.$alert(res.message + "!", "提示", {
              confirmButtonText: "确定",
            });
          } else {
            const { list, totalNumber } = res.data;
            list.map((lis) => {
              lis.createdAt = moment(new Date(lis.createdAt * 1000)).format(
                "YYYY-MM-DD"
              );
            });
            that.newData = false;
            that.tableData = list;
            that.total = totalNumber;
            that.loading = false;
          }
        });
    },
  },
  mounted() {
    var that = this;
    that.init();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/page/Cplx.vue